import { AxiosRequestConfig }   from 'axios';
import cms                      from 'lib/api/cms';
import { IFeatureFlag }         from 'types/featureFlag';

export default function getFeatureFlag(name: string, fallback: boolean, config?: AxiosRequestConfig): Promise<boolean> {
  return cms.get<IFeatureFlag>(`/cms/feature/flag/${name}`, config)
    .then(response => response.value ?? fallback)
    .catch(() => fallback)
}
